import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const includes = ['Interpretar planos complejos sin dudar', 'Diseñar circuitos de mando y potencia desde cero', 'Diagnosticar fallas en segundos en tableros industriales', 'Entender la lógica de control industrial paso a paso', 'Abrir la puerta a trabajos en fábricas y edificios', 'Dejar de depender de "probar a ver qué pasa"'];
  return <section className="py-8 md:py-14 px-4 bg-brand-bg" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <div className="text-center mb-6 md:mb-8" data-id="element-180">
          <h2 className="text-xl md:text-3xl font-black text-brand-text mb-2 uppercase leading-tight" data-id="element-181">
            EL SISTEMA DEFINITIVO:
            <br data-id="element-182" />
            <span className="text-brand-primary highlight-yellow mt-2 inline-block" data-id="element-183">
              MASTER ELECTROTÉCNICO
            </span>
          </h2>
          <p className="text-sm md:text-base font-medium text-brand-steel mt-3 max-w-3xl mx-auto" data-id="element-184">
            Esta es la solución definitiva. La guía exacta para entender la
            Lógica de Control Industrial.
          </p>
        </div>

        <div className="bg-white rounded-2xl border-2 border-brand-section shadow-xl overflow-hidden mb-6" data-id="element-185">
          <div className="bg-brand-primary py-2.5 px-4 text-center" data-id="element-186">
            <h3 className="text-sm md:text-lg font-black text-white" data-id="element-187">
              LO QUE LOGRARÁS CON ESTA GUÍA:
            </h3>
          </div>
          <div className="p-4 md:p-6" data-id="element-188">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2.5 gap-x-6" data-id="element-189">
              {includes.map((item, i) => <div key={i} className="flex items-start bg-brand-bg p-2.5 rounded-lg" data-id="element-190">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-primary mr-2 shrink-0 mt-0.5" data-id="element-191" />
                  <span className="text-xs md:text-sm text-brand-text font-bold" data-id="element-192">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-193">
          <p className="text-sm md:text-lg font-black text-brand-text leading-snug" data-id="element-194">
            Es la herramienta que te abre la puerta a{' '}
            <span className="text-brand-primary underline decoration-brand-secondary decoration-2" data-id="element-195">
              fábricas, edificios y plantas industriales.
            </span>
          </p>
        </div>
      </div>
    </section>;
}